<template>
    <div class="button-group">
        <frm-overview-actions-button v-for="(action, actionIndex) in initialActions"
                                     :key="actionIndex"
                                     :action="action"
                                     :config="config"
                                     :disabled="disabled"
                                     :handle-action="handleAction"
        />

        <button v-if="showMoreActions"
                ref="moreActionsButtonAnchor"
                type="button"
                class="button button--grouped button--small button--primary js-overview-actions-more"
                data-testid="overview-actions-more"
                :disabled="moreActionsDisabled"
                @click="triggerMoreActionsContextMenu()"
        >
            <span class="button__icon-group">
                <frm-icon name="dots" class="button__icon" />
            </span>
        </button>
    </div>
</template>

<script>
import DefaultOverviewMixin from '../../mixins/Overview/Default';
import OverviewActionsButton from './ActionsButton.vue';
import $ from 'jquery';
import buildContextMenuItemsFromActions from '../../services/buildContextMenuItemsFromActions';
import HandlesActionRestrictions from '../../mixins/Overview/HandlesActionRestrictions';
import { mapState } from '../../store/helpers';

export default {
    mixins: [DefaultOverviewMixin, HandlesActionRestrictions],

    components: {
        'frm-overview-actions-button': OverviewActionsButton,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        actions: {
            type: Array,
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        handleAction: {
            type: Function,
            required: true,
        },
    },

    mounted() {
        $(this.$el).contextMenu({
            selector: '.js-overview-actions-more',
            trigger: 'none',
            build: () => ({
                items: buildContextMenuItemsFromActions(this.moreActions,
                    (action) => this.handleAction(action),
                    (action) => this.disabled || this.actionIsRestricted(action, this.selectedRowsData)),
            }),
            determinePosition: ($menu) => {
                const position = this.$refs.moreActionsButtonAnchor.getBoundingClientRect();

                setTimeout(() => {
                    $menu.css({
                        display: 'block',
                        position: 'fixed',
                        left: (position.x - 5) + 'px',
                        top: (position.y - $menu.height() - 20) + 'px',
                    });
                });
            },
        });
    },

    methods: {
        triggerMoreActionsContextMenu() {
            $(this.$refs.moreActionsButtonAnchor).contextMenu();
        },
    },

    computed: {
        ...mapState([
            'selectedRowsData',
        ]),

        initialActions() {
            return this.actions.slice(0, this.showMoreActions ? 3 : this.actions.length);
        },

        moreActions() {
            return this.actions.slice(3);
        },

        showMoreActions() {
            return this.moreActions.length > 3;
        },

        moreActionsDisabled() {
            return this.disabled || this.moreActions.every(action => this.actionIsRestricted(action, this.selectedRowsData));
        },
    },
};
</script>
